<div *ngIf="!loading; else spinner" class="container">

  <app-scotty-card [title]="'Manage event' | translate" [canGoBack]="true" [backLevels]="2" [hideDivisor]="true">

    <span class="chip" [ngStyle]="{backgroundColor: EventTypeToColor(event.type)}">{{EventTypeToString(event.type) | translate}}</span>

    <form #form>

      <!-- Title -->
      <mat-form-field>
        <mat-label>{{ 'Title' | translate }}</mat-label>
        <input matInput [(ngModel)]="event.title" [ngModelOptions]="{standalone: true}" required [readonly]="!editable">
      </mat-form-field>

      <!-- Description -->
      <mat-form-field>
        <mat-label>{{ 'Description' | translate }}</mat-label>
        <textarea matInput [(ngModel)]="event.description" [ngModelOptions]="{standalone: true}" [readonly]="!editable"></textarea>
      </mat-form-field>

      <!-- Equipment -->
      <mat-form-field appearance="fill">
        <mat-label>{{ 'Equipment' | translate }}</mat-label>
        <mat-select [(ngModel)]="equipmentId" [ngModelOptions]="{standalone: true}" (ngModelChange)="getPhysicalAssets()" required [disabled]="!editable">
          <mat-option>
            <ngx-mat-select-search [placeholderLabel]="'Search equipment...' | translate" [(ngModel)]="equipmentFilter" (ngModelChange)="updateFilteredEquipments()" [ngModelOptions]="{standalone: true}"></ngx-mat-select-search>
          </mat-option>
          <mat-option *ngIf="!equipments || filteredEquipments.length == 0">{{ 'No equipment found' | translate }}</mat-option>
          <mat-option *ngFor="let equipment of filteredEquipments" [value]="equipment.id">
            {{equipment.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Asset -->
      <mat-form-field appearance="fill">
        <mat-label>{{ 'Physical asset' | translate }}</mat-label>
        <mat-select [(ngModel)]="assetId" [ngModelOptions]="{standalone: true}" required [disabled]="!editable">
          <mat-option>
            <ngx-mat-select-search [placeholderLabel]="'Search asset...' | translate" [(ngModel)]="assetFilter" (ngModelChange)="updateFilteredAssets()" [ngModelOptions]="{standalone: true}"></ngx-mat-select-search>
          </mat-option>
          <mat-option *ngIf="!assets || filteredAssets.length == 0">{{ 'No physical asset found' | translate }}</mat-option>
          <mat-option *ngFor="let asset of filteredAssets" [value]="asset.id">
            {{asset.serialNumber}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Start date -->
      <mat-form-field>
        <input matInput [ngxMatDatetimePicker]="pickerStartDate" [placeholder]="'Start date' | translate" [(ngModel)]="event.scheduledAtDate" [ngModelOptions]="{standalone: true}" [min]="now" (dateChange)="startDateChanged()" required readonly>
        <mat-datepicker-toggle *ngIf="editable || canBindPersonnel()" matSuffix [for]="pickerStartDate"></mat-datepicker-toggle>
        <ngx-mat-datetime-picker #pickerStartDate [showSpinners]="true" [showSeconds]="true" [stepHour]="1"
                                 [stepMinute]="1" [stepSecond]="1" color="primary"
                                 [enableMeridian]="true" [hideTime]="false">
        </ngx-mat-datetime-picker>
      </mat-form-field>

      <!-- End date -->
      <mat-form-field>
        <input matInput [ngxMatDatetimePicker]="pickerEndDate" [placeholder]="'End date' | translate" [(ngModel)]="event.endAtDate" [ngModelOptions]="{standalone: true}" [min]="event.scheduledAtDate" required readonly>
        <mat-datepicker-toggle *ngIf="editable" matSuffix [for]="pickerEndDate"></mat-datepicker-toggle>
        <ngx-mat-datetime-picker #pickerEndDate [showSpinners]="true" [showSeconds]="true" [stepHour]="1"
                                 [stepMinute]="1" [stepSecond]="1" color="primary"
                                 [enableMeridian]="true" [hideTime]="false">
        </ngx-mat-datetime-picker>
      </mat-form-field>

      <!-- Training url -->
      <ng-container *ngIf="event.id && event.type == EventType.TRAINING">

        <div *ngIf="event.trainingUrl" class="row">
          <mat-form-field>
            <mat-label>{{ 'Training url' | translate }}</mat-label>
            <input matInput [(ngModel)]="event.trainingUrl" [ngModelOptions]="{standalone: true}" readonly>
          </mat-form-field>
          <button mat-stroked-button color="primary" (click)="copyToClipboard(event.trainingUrl, $event.target)">{{ 'Copy' | translate }}</button>
        </div>

        <!-- Generate link button -->
        <!--<ng-container *ngIf="(!data.metadata || !data.metadata.url) && editable">
          <div class="label">Training url</div>
          <button mat-flat-button color="primary" (click)="generateTrainingRoom()">Generate link</button>
        </ng-container>-->

      </ng-container>

      <!-- Access code -->
      <ng-container *ngIf="event.id && event.type == EventType.TRAINING && event.isPublic">
        <mat-form-field *ngIf="event.trainingUrl && event.accessCode">
          <mat-label>{{ 'Access code' | translate }}</mat-label>
          <input matInput [(ngModel)]="event.accessCode" [ngModelOptions]="{standalone: true}" readonly>
        </mat-form-field>
      </ng-container>

      <!-- Is public event -->
      <mat-checkbox *ngIf="event.type == EventType.TRAINING" color="primary" class="public-event" [(ngModel)]="event.isPublic" [ngModelOptions]="{standalone: true}">{{ 'Public event' | translate }}</mat-checkbox>

      <!-- Procedure bind -->
      <mat-form-field appearance="fill">
        <mat-label>{{ 'Bind existing procedure' | translate }}</mat-label>
        <mat-select [(ngModel)]="procedureId" [ngModelOptions]="{standalone: true}">
          <mat-option>
            <ngx-mat-select-search [placeholderLabel]="'Search procedure...' | translate" [(ngModel)]="procedureFilter" (ngModelChange)="updateFilteredProcedures()" [ngModelOptions]="{standalone: true}"></ngx-mat-select-search>
          </mat-option>
          <mat-option *ngIf="!procedures || filteredProcedures.length == 0">{{ 'No procedure found' | translate }}</mat-option>
          <mat-option *ngFor="let procedure of filteredProcedures" [value]="procedure.id">
            {{procedure.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Is expert support required -->
      <ng-container *ngIf="event.type == EventType.PLANNED_MAINTENANCE">
        <mat-checkbox color="primary" [(ngModel)]="isSupportRequired" [ngModelOptions]="{standalone: true}" (change)="updateIsSupportRequired()">{{ 'Require expert support' | translate }}</mat-checkbox>
      </ng-container>

      <!-- Personnel binding -->
      <ng-container *ngIf="!isNew && event.id && event.type == EventType.PLANNED_MAINTENANCE">

        <h3 class="subtitle">{{ 'Maintenance assignment' | translate }}</h3>
        <div *ngIf="recommendations && recommendations.modality" class="recommended-mode">{{ 'Recommended mode' | translate }}: {{recommendations.modality}}</div>

        <!-- Field worker bind -->
        <mat-form-field appearance="fill">
          <mat-label>{{ 'Assign field worker' | translate }}</mat-label>
          <mat-select [disabled]="!canBindPersonnel()" [(ngModel)]="event.maintenance.fieldWorker.id" [ngModelOptions]="{standalone: true}">
            <mat-option>
              <ngx-mat-select-search [placeholderLabel]="'Search field worker...' | translate" [(ngModel)]="fieldWorkerFilter" [ngModelOptions]="{standalone: true}" (ngModelChange)="filterPersonnel()"></ngx-mat-select-search>
            </mat-option>
            <mat-option *ngIf="!recommendations.fieldWorkers || filteredFieldWorkers.length == 0">{{ 'No field worker found' | translate }}</mat-option>
            <mat-option *ngFor="let fieldWorker of filteredFieldWorkers" [value]="fieldWorker.userSkill.user.id">
              <mat-icon color="primary">{{fieldWorker.hasRequiredLevel ? 'person' : 'people'}}</mat-icon>
              <span>{{fieldWorker.userSkill.user.lastName}} {{fieldWorker.userSkill.user.firstName}}  <ng-container *ngIf="fieldWorker.userSkill.skill && fieldWorker.userSkill.skillLevel">({{fieldWorker.userSkill.skill.name}} - {{fieldWorker.userSkill.skillLevel.name}})</ng-container></span><br>
              <span *ngIf="fieldWorker.userSkill.expiringAt" class="skill-expiring indent">{{ 'Expiring at' | translate }}: {{fieldWorker.userSkill.expiringAt | date:'dd/MM/yy'}}</span>
            </mat-option>
            <mat-select-trigger>{{getFieldWorker()}}</mat-select-trigger>
          </mat-select>
        </mat-form-field>

        <!-- Remote Expert bind -->
        <mat-form-field *ngIf="isSupportRequired && !hasRequiredLevel()" appearance="fill">
          <mat-label>{{ 'Assign remote expert' | translate }}</mat-label>
          <mat-select [disabled]="!canBindPersonnel()" [(ngModel)]="event.maintenance.remoteExpert.id" [ngModelOptions]="{standalone: true}">
            <mat-option>
              <ngx-mat-select-search [placeholderLabel]="'Search remote expert...' | translate" [(ngModel)]="expertFilter" [ngModelOptions]="{standalone: true}" (ngModelChange)="filterPersonnel()"></ngx-mat-select-search>
            </mat-option>
            <mat-option *ngIf="!recommendations.remoteExperts || filteredExperts.length == 0">{{ 'No remote expert found' | translate }}</mat-option>
            <mat-option *ngFor="let expert of filteredExperts" [value]="expert.user.id">
              {{expert.user.lastName}} {{expert.user.firstName}} <ng-container *ngIf="expert.skill && expert.skillLevel">({{expert.skill.name}} - {{expert.skillLevel.name}})</ng-container> <br><span *ngIf="expert.expiringAt" class="skill-expiring">{{ 'Expiring at' | translate }}: {{expert.expiringAt | date:'dd/MM/yy'}}</span>
            </mat-option>
            <mat-select-trigger>{{getRemoteExpert()}}</mat-select-trigger>
          </mat-select>
        </mat-form-field>

      </ng-container>

    </form>

    <!-- Action buttons -->
    <div [ngSwitch]="event.type" class="actions">

      <ng-container *ngIf="event.id && event.type == EventType.TRAINING || (event.type == EventType.PLANNED_MAINTENANCE && event.maintenance && event.maintenance.status == MaintenanceStatus.PLANNED)">
        <button mat-flat-button color="warn" (click)="remove()" class="remove-button">{{ 'Remove event' | translate }}</button>
      </ng-container>

      <div class="spacer"></div>

      <div>

        <ng-container *ngIf="!isNew">
          <button *ngSwitchCase="EventType.PLANNED_MAINTENANCE" mat-flat-button color="primary" cdkFocusInitial [disabled]="!canBindPersonnel() || !isValid(form)" (click)="save(false);">{{ 'Update' | translate }}</button>
        </ng-container>

        <ng-container *ngIf="isNew && editable">
          <!--<button mat-stroked-button (click)="onNoClick()">{{ 'Cancel' | translate }}</button>-->
          <ng-container *ngSwitchCase="EventType.TRAINING"><ng-container *ngTemplateOutlet="saveButton"></ng-container></ng-container>
          <ng-container *ngSwitchCase="EventType.PLANNED_MAINTENANCE"><ng-container *ngTemplateOutlet="saveButton"></ng-container></ng-container>
          <ng-template #saveButton>
            <button mat-flat-button color="primary" cdkFocusInitial [disabled]="!isValid(form)" (click)="save(true)">{{ 'Save' | translate }}</button>
          </ng-template>
        </ng-container>

        <ng-container *ngIf="!editable">
          <!-- Back button -->
          <!--<button mat-stroked-button (click)="onNoClick()">Back</button>-->
          <!-- Check if an open or closed extraordinary maintenance -->
          <ng-container *ngSwitchCase="EventType.EXT_MAINTENANCE">
            <button *ngIf="event.endAtDate" mat-flat-button color="primary" cdkFocusInitial (click)="goToMaintenanceReport()">{{ 'View report' | translate }}</button>
            <button *ngIf="!event.endAtDate" mat-flat-button color="primary" cdkFocusInitial (click)="goToMaintenances()">{{ 'Go to maintenances' | translate }}</button>
          </ng-container>
        </ng-container>

      </div>

    </div>

  </app-scotty-card>

</div>

<ng-template #spinner>
  <app-scotty-spinner></app-scotty-spinner>
</ng-template>
